module.exports = __webpack_public_path__ + "img/assets/logo-rebelia@2x.png";